/**
 * SKU код үүсгэхэд ЗААВАЛ бөглөсөн байх талбарууд ба тэдгээрийн шалгалт.
 *
 * SKU нь өөрөө заавал талбар тул эдгээр нь угтаа бараа үүсгэхэд шаардлагатай
 * талбарууд юм. Тиймээс формын дүрмүүд ЭНЭ жагсаалтуудтай тааруулагдсан байх
 * ёстой — эс тэгвээс "заавал биш" гэж тэмдэглэгдсэн талбар SKU-г нууцаар
 * блоклож, хэрэглэгч бараагаа огт үүсгэж чадахгүй болно.
 *
 * Сервер SKU-г `merchantCode-categoryCode-<текстээс үүсгэсэн код>` хэлбэрээр
 * угсардаг (ppmerchant → handlers/03_merchant_product/services/sku.js).
 * `merchantCode`-ыг нэвтэрсэн хэрэглэгчээс өөрөө авдаг тул клиентээс шалгахгүй.
 *
 * Жагсаалтуудын дараалал нь формын талбаруудын дараалалтай ижил — мэдэгдэл дээр
 * ч мөн адил дарааллаар нэрлэгдэнэ.
 */

/**
 * Нэгж бараа. Текстийг нь тайлбараас авдаг бөгөөд тайлбар нь формд аль хэдийн
 * заавал тул энд давхар шалгахгүй.
 */
export const SKU_REQUIRED_FIELDS = [
  { name: 'brand', label: 'Бренд' },
  { name: 'category', label: 'Категори' },
];

/** Багц бараа. Текстийг нь багцын нэрнээс авдаг тул нэр нь ч мөн шаардлагатай. */
export const GROUP_SKU_REQUIRED_FIELDS = [
  { name: 'title', label: 'Багц барааны нэр' },
  { name: 'brand', label: 'Бренд' },
  { name: 'category', label: 'Категори' },
];

/**
 * Нэгж барааны SKU-д ШАЛГАХ талбарууд.
 *
 * Эрээний (EHW) мерчантад брэнд, категори талбарууд формд огт харагддаггүй —
 * систем өөрөө утгыг нь тавьдаг тул шалгах зүйлгүй. Шалгавал тэдгээр мерчант
 * SKU үүсгэж чадахгүй болно.
 */
export const getSkuRequiredFields = ({ isErlian = false } = {}) =>
  isErlian ? [] : SKU_REQUIRED_FIELDS;

/**
 * SKU үүсгэхэд дутуу байгаа талбаруудыг буцаана.
 *
 * @param {Array<{name: string, label: string}>} fields шалгах талбарууд
 * @param {object} values формын/контекстийн утгууд
 * @returns {Array<{name: string, label: string}>} дутуу талбарууд
 */
export const findMissingSkuFields = (fields = [], values = {}) =>
  fields.filter(({ name }) => !String(values?.[name] ?? '').trim());

/**
 * ЗӨВХӨН дутуу байгаа талбаруудыг нэрлэсэн мэдэгдэл.
 *
 * Өмнө нь "Барааны нэр, Брэнд, ангилал сонгоогүй байна!" гэж гурвуулангийг нь
 * үргэлж зэрэг дурддаг байсан тул хэрэглэгч алийг нь бөглөхөө мэдэхгүй байв.
 */
export const missingSkuFieldsMessage = (missing = []) =>
  `${missing.map(({ label }) => label).join(', ')} бөглөөгүй байна!`;
